import './promise-polyfill'
import './polyfills'
import Vue from 'vue'
import 'config/api.conf'
import TurboUi from '@hfe/turbo-ui';
import '@hfe/turbo-ui/dist/turbo.min.css'
import 'styles/base.pcss'
import { app } from './app'
import VueClipboard from 'vue-clipboard2';
import VoicePlayer from 'components/Player/player';
import OrdersInDialog from "components/ConfirmOrders/orders";
import TitleMessager from 'components/TitleMessager/TitleMessager';
import '@hfe/paprika';

VoicePlayer.install(Vue);
TitleMessager.install(Vue);
Vue.use(TurboUi)
window.Vue = Vue;
Vue.use(VueClipboard);
Vue.component('OrdersInDialog', OrdersInDialog)

app.$mount('#app')


// WEBPACK FOOTER //
// ./src/index.js